import React, { useRef } from "react";
import { motion, useInView } from "framer-motion";

export default function TeamMember() {
  // Tạo ref cho mỗi thành viên
  const memberRefs = Array.from({ length: 8 }, () => useRef(null));

  // Kiểm tra xem các thành viên đã xuất hiện trong viewport chưa
  const memberInView = memberRefs.map((ref) =>
    useInView(ref, { threshold: 0.1 })
  );

  const createAnimationVariant = (delay) => ({
    hidden: { opacity: 0, rotateY: 90 }, // Start hidden and rotated by 90 degrees on Y axis
    visible: {
      opacity: 1,
      rotateY: 0,
      transition: { duration: 0.8, delay }, // Add delay for each member
    },
  });

  return (
    <div className="flex flex-col items-center bg-white">
      <img
        className="mt-[25px]"
        src="/icons/tamMember/1.png"
        alt="Team Header"
      />
      <div className="grid grid-cols-4 mb-10 gap-2 mr-3 mt-[45px]">
        {/* Member 1 */}
        <motion.div
          className="relative"
          ref={memberRefs[0]} // Gán ref
          variants={createAnimationVariant(0)} // No delay for the first member
          initial="hidden"
          animate={memberInView[0] ? "visible" : "hidden"} // Kiểm tra xem đã vào viewport chưa
        >
          <img
            className="w-[351px]"
            src="/icons/tamMember/ANH-DONG-IMG.png"
            alt="Dong Huynh"
          />
          <div
            style={{
              background: " rgba(68, 66, 66, 0.69)",
            }}
            className="absolute  bg-[length:351px_200px] w-[351px]    pt-[15px] pb-[22px]  flex flex-col items-center bottom-0 font-bold text-lg text-[#FFFFFF]"
          >
            <h4 className="leading-10">Peter, Dong Huynh</h4>
            <h4 className="text-[#aeaeaf] leading-[18px] ">President</h4>
          </div>
        </motion.div>

        {/* Member 2 */}
        <motion.div
          className="relative"
          ref={memberRefs[1]}
          variants={createAnimationVariant(0.2)} // Add 0.2s delay
          initial="hidden"
          animate={memberInView[1] ? "visible" : "hidden"}
        >
          <img
            className="w-[351px]"
            src="/icons/tamMember/so2.png"
            alt="Sang Nguyen"
          />
          <div
            style={{
              background: " rgba(68, 66, 66, 0.69)",
            }}
            className="absolute  bg-[length:351px_200px] w-[351px]    pt-[15px] pb-[22px]  flex flex-col items-center bottom-0 font-bold text-lg text-[#FFFFFF]"
          >
            <h4 className="leading-10">John, Sang Nguyen</h4>
            <h4 className="text-[#aeaeaf] leading-[18px] ">Vice President</h4>
          </div>
        </motion.div>

        {/* Member 3 */}
        <motion.div
          className="relative"
          ref={memberRefs[2]}
          variants={createAnimationVariant(0.4)} // Add 0.2s delay
          initial="hidden"
          animate={memberInView[2] ? "visible" : "hidden"}
        >
          <img
            className="w-[351px]"
            src="/icons/tamMember/so3.png"
            alt="Tra Chau"
          />
          <div
            style={{
              background: " rgba(68, 66, 66, 0.69)",
            }}
            className="absolute  bg-[length:351px_200px] w-[351px]    pt-[15px] pb-[22px]  flex flex-col items-center bottom-0 font-bold text-lg text-[#FFFFFF]"
          >
            <h4 className="leading-10">Anthony, Tuan Nguyen</h4>
            <h4 className="text-[#aeaeaf] leading-[18px] ">
              Chief Executive Officer
            </h4>
          </div>
        </motion.div>
        {/* Member 4 */}
        <motion.div
          className="relative"
          ref={memberRefs[3]}
          variants={createAnimationVariant(0.6)} // Add 0.2s delay
          initial="hidden"
          animate={memberInView[3] ? "visible" : "hidden"}
        >
          <img
            className="w-[351px]"
            src="/icons/tamMember/ANH-TRA-IMG.png"
            alt="Tra Chau"
          />
          <div
            style={{
              background: " rgba(68, 66, 66, 0.69)",
            }}
            className="absolute  bg-[length:351px_200px] w-[351px]    pt-[15px] pb-[22px]  flex flex-col items-center bottom-0 font-bold text-lg text-[#FFFFFF]"
          >
            <h4 className="leading-10">Jacob, Tra Chau</h4>
            <h4 className="text-[#aeaeaf] leading-[18px] ">
              Head of Client Relationship
            </h4>
          </div>
        </motion.div>
        {/* Member 5 */}
        <motion.div
          className="relative"
          ref={memberRefs[4]}
          variants={createAnimationVariant(0.8)} // Add 0.2s delay
          initial="hidden"
          animate={memberInView[4] ? "visible" : "hidden"}
        >
          <img
            className="w-[351px]"
            src="/icons/tamMember/CHI-ANH-IMG.png"
            alt="Anh Nguyen"
          />
          <div
            style={{
              background: " rgba(68, 66, 66, 0.69)",
            }}
            className="absolute  bg-[length:351px_200px] w-[351px]    pt-[15px] pb-[22px]  flex flex-col items-center bottom-0 font-bold text-lg text-[#FFFFFF]"
          >
            <h4 className="leading-10">Alice, Anh Nguyen</h4>
            <h4 className="text-[#aeaeaf] leading-[18px] ">
              Head of Business Development
            </h4>
          </div>
        </motion.div>
        {/* Member 6 */}
        <motion.div
          className="relative"
          ref={memberRefs[5]}
          variants={createAnimationVariant(1)} // Add 0.2s delay
          initial="hidden"
          animate={memberInView[5] ? "visible" : "hidden"}
        >
          <img
            className="w-[351px]"
            src="/icons/tamMember/so6.png"
            alt="Thanh Son"
          />
          <div
            style={{
              background: " rgba(68, 66, 66, 0.69)",
            }}
            className="absolute  bg-[length:351px_200px] w-[351px]    pt-[15px] pb-[22px]  flex flex-col items-center bottom-0 font-bold text-lg text-[#FFFFFF]"
          >
            <h4 className="leading-10">Jack, Thanh Son</h4>
            <h4 className="text-[#aeaeaf] leading-[18px] ">
              Head of HR Outsourcing - Commercial
            </h4>
          </div>
        </motion.div>

        {/* Member 7 */}
        <motion.div
          className="relative"
          ref={memberRefs[6]}
          variants={createAnimationVariant(1.2)} // Add 0.2s delay
          initial="hidden"
          animate={memberInView[6] ? "visible" : "hidden"}
        >
          <img
            className="w-[351px]"
            src="/icons/tamMember/ANH-VU-IMG.png"
            alt="Vu Nguyen"
          />

          <div
            style={{
              background: " rgba(68, 66, 66, 0.69)",
            }}
            className="absolute bg-[length:351px_190px] w-[351px] -right-0  pt-[4px] pb-[15px]  flex flex-col items-center bottom-0 font-bold text-lg text-[#FFFFFF]"
          >
            <h4 className="leading-10">Simon, Vu Nguyen</h4>
            <h4 className="text-[#aeaeaf] leading-[18px] ">
              Head of Universal
            </h4>
            <h4 className="text-[#aeaeaf] leading-[18px]">
              Production Process Outsourcing
            </h4>
          </div>
        </motion.div>
        {/* Member 8 */}
        <motion.div
          className="relative"
          ref={memberRefs[7]}
          variants={createAnimationVariant(1.4)}
          initial="hidden"
          animate={memberInView[7] ? "visible" : "hidden"}
        >
          <img
            className="w-[351px]"
            src="/icons/tamMember/so8.png"
            alt="Vu Nguyen"
          />
          <div
            style={{
              background: " rgba(68, 66, 66, 0.69)",
            }}
            className="absolute  bg-[length:351px_200px] w-[351px]    pt-[15px] pb-[22px]  flex flex-col items-center bottom-0 font-bold text-lg text-[#FFFFFF]"
          >
            <h4 className="leading-10">Nathan, Nam Hoang</h4>
            <h4 className="text-[#aeaeaf] leading-[18px] ">
              Head of Field Marketing Solutions
            </h4>
          </div>
        </motion.div>
      </div>
    </div>
  );
}
